// extracted by mini-css-extract-plugin
export default {"error_info":"_404_error_info__S0Mnq","content":"_404_content__wpxiJ"};